/* search for lower case */
function hasLowercase(password) {
    const regEx = /[a-z]/;
    return regEx.test(password);
};

/* search for upper case */
function hasUppercase (password){
    const regEx = /[A-Z]/;
    return regEx.test(password);
};

/* search for digit case */
function hasDigit (password){
    const regEx = /[0-9]/;
    return regEx.test(password);
};

/* search for special character */
function hasSpecialCharacter(password){
    const regEx = /[^a-zA-Z0-9]/;
    return regEx.test(password);
};

export const validatePassword = (password, minLength) => {
    const errors = [];
    
    if (password.length === 0 || password === null) {
        errors.push('Password cannot be empty!');
    }

    if (password.length < minLength) {
        errors.push('Password must be at least ' + minLength + ' characters long!');
    }
    
    if (!hasLowercase(password)) {
        errors.push('Password must have at least one lower case character!');
    }

    if (!hasUppercase(password)) {
        errors.push('Password must have at least one upper case character!');
    }

    if (!hasDigit(password)) {
        errors.push('Password must have at least one digit!');
    }

    if (!hasSpecialCharacter(password)) {
        errors.push('Password must have at least one special character!');
    }

    return errors;
};

